<template>
    <div>
      <router-view></router-view> <!-- 子路由会在这里渲染 -->
    </div>
  </template>
  
  <script>
  export default {
    name: 'UserManagement',
    computed: {
      activeTab() {
        return this.$route.path.split('/').pop();
      }
    },
    methods: {
      handleTabChange(index) {
        this.$router.push({ path: `/home/user-management/${index}` });
      }
    }
  };
  </script>
  
  <style scoped>
  .el-menu {
    margin-bottom: 20px;
  }
  </style>